import { IconButton, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { ASSET_SEARCH_FIELDS_LABEL } from "./server/lib/assets-search-fields.mjs"

export function AssetTableSearchableTooltip() {
    return (
        <Tooltip title={`Searchable columns: ${ASSET_SEARCH_FIELDS_LABEL}`} arrow placement="top">
            <IconButton data-cy="asset-search-columns-info" size="small">
                <Iconify icon="mdi:information-outline" width="20px" height="20px" />
            </IconButton>
        </Tooltip>
    )
}
